import AccountPaymentCard from './account-payment-card/account-payment-card.vue';
import AccountPaymentCardUpdate from './account-payment-card-update/account-payment-card-update.vue';

export default {
  name: 'account-payment',
  components: {
    AccountPaymentCard,
    AccountPaymentCardUpdate,
  },
  props: {
    stripe: {
      type: Object,
    },
    paymentMethod: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUpdateModal: false,
    };
  },
  computed: {
    cardHolderName() {
      return this.paymentMethod && this.paymentMethod.billing_details ? this.paymentMethod.billing_details.name : '';
    },
    card() {
      return this.paymentMethod && this.paymentMethod.card ? this.paymentMethod.card : {};
    },
  },
  methods: {
    handleUpdate() {
      this.showUpdateModal = true;
    },
    handleClose() {
      this.showUpdateModal = false;
    },
  },
};
